import * as React from "react";
import { Input } from "./input";
import { Checkbox } from "./checkbox";
import { Search } from "lucide-react";

export function SearchableCheckboxList({
  items = [],
  selectedIds = [],
  onToggle,
  idPrefix = "item",
  placeholder = "Cerca...",
  emptyText = "Nessun elemento disponibile",
  noResultsText = "Nessun risultato",
  labelKey = "name",
}) {
  const [search, setSearch] = React.useState("");

  const filtered = React.useMemo(() => {
    if (!search) return items;
    const q = search.toLowerCase();
    return items.filter((item) =>
      (item[labelKey] || "").toLowerCase().includes(q)
    );
  }, [items, search, labelKey]);

  if (items.length === 0) {
    return (
      <div className="border rounded-md p-2 text-sm">
        <p className="text-xs text-gray-500">{emptyText}</p>
      </div>
    );
  }

  return (
    <div className="border rounded-md text-sm">
      {items.length > 3 && (
        <div className="relative px-2 pt-2">
          <Search className="absolute left-4 top-4 h-3.5 w-3.5 text-gray-400" />
          <Input
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder={placeholder}
            className="h-7 pl-7 text-xs"
          />
        </div>
      )}
      <div className="p-2 space-y-1 max-h-32 overflow-y-auto">
        {filtered.length === 0 ? (
          <p className="text-xs text-gray-500 py-1">{noResultsText}</p>
        ) : (
          filtered.map((item) => (
            <div key={item.id} className="flex items-center space-x-2">
              <Checkbox
                id={`${idPrefix}-${item.id}`}
                checked={selectedIds.includes(item.id)}
                onCheckedChange={(checked) => onToggle(item.id, checked)}
              />
              <label
                htmlFor={`${idPrefix}-${item.id}`}
                className="text-sm cursor-pointer"
              >
                {item[labelKey]}
              </label>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
